import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSankeyChart: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sankey-chart"><path d="M3.75 5.75C10.9113 5.75 13.0887 14.25 20.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 11.75C10.3198 11.75 13.6802 18.25 20.25 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 5.75C12.489 5.75 12.0982 18.25 3.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSankeyChart;
